export const AGE_OPTIONS = [
    { value: 'under_equal_13', label: '13 oder jünger' },
    // { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '15', label: '15' },
    { value: '16', label: '16' },
    { value: '17', label: '17' },
    // { value: '18', label: '18' },
    { value: 'above_equal_18', label: '18 oder älter' },
] as const

export const AGE_VALUES = AGE_OPTIONS.map((option) => option.value) as [
    (typeof AGE_OPTIONS)[number]['value'],
    ...(typeof AGE_OPTIONS)[number]['value'][],
]

const ADULT_AGE_VALUES: ReadonlySet<AgeValue> = new Set(['16', '17', 'above_equal_18'])

export type AgeValue = (typeof AGE_OPTIONS)[number]['value']

export function isAdult(age: AgeValue): boolean {
    return ADULT_AGE_VALUES.has(age)
}
